import { useAuth } from "@/auth/hooks/useAuth";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import slugify from "slugify";

const Home = () => {
  const { isAuthenticated, user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (loading || hasNavigated.current) return;

    hasNavigated.current = true;

    if (!isAuthenticated || !user) {
      navigate("/login", { replace: true });
    } else if (!user?.roles?.includes("ROLE_FUNDER")) {
      logout();
      navigate("/login", { replace: true });
    } else if (user?.fullname) {
      navigate(`/${slugify(user.fullname, { lower: true, trim: true })}`, {
        replace: true,
      });
    }
  }, [loading, isAuthenticated, user, navigate]);

  return <div className="container"></div>;
};

export default Home;
